import { getOktaAuth } from "services/oktaService";

const OktaRedirect = () => {
  getOktaAuth().signInWithRedirect();
  return <div>Sending you to Okta...</div>;
};

export { OktaRedirect };
